/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import router from "next/router";
import { toast } from "react-toastify";

import { API } from "src/classes/api";
import { TOAST_DEFAULT_ARGS } from "src/lib/constants";

export const updateTitle = ({
  id,
  username,
  title,
}: {
  id: string;
  username: string;
  title: string;
}): Promise<{ succeeded: boolean }> => {
  return API.plates
    .updateSettings(id, { title })
    .then((updatedPage) => {
      router.replace(`/plate/${username}/${encodeURIComponent(updatedPage.title)}`);
      return { succeeded: true };
    })
    .catch((err) => {
      toast.error(err.message || "Failed to update plate title", TOAST_DEFAULT_ARGS);
      return { succeeded: false };
    });
};

export const updateEditors = ({
  plateId,
  editorId,
  action,
}: {
  plateId: string;
  editorId: string;
  action: "ADD" | "REMOVE";
}): Promise<{ succeeded: boolean }> => {
  const success = API.plates
    .updateEditors(plateId, editorId, action)
    .then((plate) => {
      toast.success(`Updated editors: ${plate.title}`, TOAST_DEFAULT_ARGS);
      return { succeeded: true };
    })
    .catch((_err) => {
      toast.error("Failed to update editors");
      return { succeeded: false };
    });
  return success;
};
